// Reads the admin-configured upload limits (size + allowed extensions) from the public
// settings endpoint and turns them into typed constraints for the uploader. Always returns a
// valid object: while loading or on error it yields the safe defaults from uploadConstraints.

import { useQuery } from '@tanstack/react-query';
import { settingsApi } from '@api/settings';
import { parseUploadConstraints, type UploadConstraints } from '../uploadConstraints';

export function useUploadConstraints(): UploadConstraints {
  const { data } = useQuery({
    queryKey: ['settings', 'public'],
    queryFn: () => settingsApi.listPublic(),
    staleTime: 5 * 60 * 1000,
  });
  return parseUploadConstraints(data ?? []);
}
